import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import $ from 'jquery';
import CKEditor from "react-ckeditor-component";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DatePicker from 'react-datepicker'; 
import moment from 'moment';
class ViewStory extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            story_workflow: [],
            story_status: [],
            er_note_attachment: [],
            workflow: [],
            feature_id: '',
            owners: [],
            errors: {},
            story_attachment: [],
            monitor_er: [],
            er_story: [],
            story_history: [],
            notes: [],
            value: 0,
            status_name: '',
            note: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userEmail: has_local_data ? localdata.user_email : '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
        }
        this.AddNote = this.AddNote.bind(this);
        this.ckOnChange1 = this.ckOnChange1.bind(this);
        this.startdateChange = this.startdateChange.bind(this);
        this.enddateChange = this.enddateChange.bind(this);
		this.onStartSaveClick = this.onStartSaveClick.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    onChange(propertyName, event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleChange = (event, index, value) => {
        this.setState({ value: value });
    }

    AddNote(e) {
        let errors = {};
        document.getElementById("add_note").innerHTML = "Sending....";
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('attachments').files[x]);
            }
        }
        document.getElementById("add_note").disabled = true;
        fd.append('note', this.state.note);
        fd.append('story_id', this.props.match.params.storyId);
        fd.append('sequence_no', this.props.match.params.seqNo);
        fetch(this.state.apiUrl + '/ErRest/AddStoryNote/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        errors["note"] = "";
                        this.setState({ errors: errors });
                        window.location.href = '/viewStory/' + this.state.er_story.id + '/sequence/' + this.props.match.params.seqNo;
                    });
                } else {
                    errors["note"] = findresponse.msg;
                    this.setState({ errors: errors });
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    NoteEditCondition(id, note) {
        return (
            <a href="javascript:void(0)" onClick={() => this.setNote(id, note, this.props.match.params.seqNo)}> <i class="fa fa-edit"></i></a>
        )
    }

    setNote(id, note, sequence_no) {
        localStorage.setItem('ticket_note', note);
        this.props.history.push('/NoteStoryEdit/' + id + '/sequence/' + sequence_no);
    }

    getStoryDetails() {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.intranet_body').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/ErRest/viewStory/id/' + this.props.match.params.storyId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                $(document).ready(function () {
                    $('.loader-new').addClass('hidden');
                    $('.intranet_body').removeClass('hidden');
                });
                console.log(responseJson)
                this.setState({
                    reporter: responseJson.reporter,
                    assigned_to: responseJson.assigned_to,
                    er_story: responseJson.er_story,
                    config: responseJson.config,
                    owners: responseJson.owners,
                    formatted_owners: responseJson.formatted_owners,
                    monitor_er: responseJson.monitor_er,
                    story_attachment: responseJson.story_attachment,
                    feature_id: responseJson.feature_id,
                    workflow: responseJson.workflow,
                    status_name: responseJson.er_story.status,
                    notes: responseJson.notes,
                    er_note_attachment: responseJson.er_note_attachment,
                    story_history: responseJson.story_history,
                    story_status: responseJson.story_status,
                    story_workflow: responseJson.story_workflow
                })
                if (this.state.er_story.date_start) {
                    let x = Date.parse(this.state.er_story.date_start);
                    this.setState({ startdate: moment(x) })
                }
                if (this.state.er_story.date_end) {
                    let x = Date.parse(this.state.er_story.date_end);
                    this.setState({ enddate: moment(x) })
                }
                if (this.state.er_story.date_created) {
                    let x = Date.parse(this.state.er_story.date_created);
                    this.setState({ createddate: moment(x) })
                }
                document.title = responseJson.er_story.feature_id + '_' + this.props.match.params.seqNo;
            })
    }

    ckOnChange1(evt) {
        var ckContent = evt.editor.getData();
        if (this.state.note.toLowerCase() != ckContent.toLowerCase()) {
            this.setState({
                note: ckContent
            })
            var obj = this;
            setTimeout(function () {
                ckContent = ckContent.replace(/<\/p>$/, "");
                var nameRegex = /@[a-zA-Z]+$/;
                var matches = ckContent.match(nameRegex);
                if (matches && matches.length > 0) {
                    var indx = matches['index'];
                    var query = matches[0].replace('@', '');
                    if (query) {
                        var result = [];
                        var filterObj = obj.state.owners.filter(function (e) {
                            if (e.name.toLowerCase().includes(query.toLowerCase())) {
                                result.push(e.name);
                            }
                        });
                        var mtchitems = '';
                        if (result.length > 0) {
                            for (var i in result) {
                                mtchitems += '<li class="auto-suggest-li" style="padding:5px;cursor:pointer;background:#ccc;margin-bottom:1px;" >' + result[i] + '</li>';
                                if (i == result.length - 1) {
                                    mtchitems = '<ul style="list-style:none" class="auto-suggest-ul">' + mtchitems + '</ul>';
                                    document.getElementById('note_autoseggestion').innerHTML = mtchitems;
                                    $('.auto-suggest-li').on('click', function (event) {
                                        var final_string = ckContent.substring(0, indx) + "@" + event.target.innerText.trim();
                                        evt.editor.setData(final_string);
                                        obj.setState({
                                            note: final_string,
                                        })

                                        document.getElementById('note_autoseggestion').innerHTML = "";
                                        evt.editor.focus();
                                    });
                                }
                            }
                        } else {
                            document.getElementById('note_autoseggestion').innerHTML = "";
                        }
                    }
                } else {
                    document.getElementById('note_autoseggestion').innerHTML = "";
                }
            }, 300);
        } else {
            evt.editor.focus();
        }
    }

    showImage(s3url, filename) {
        // Construct the 'a' element
        var link = document.createElement("a");
        link.download = filename;
        link.target = "_blank";
        // Construct the URI
        link.href = s3url;
        document.body.appendChild(link);
        link.click();
        // Cleanup the DOM
        document.body.removeChild(link);
    }

    downloadImage(id) {
        var win = window.open(this.state.apiUrl + '/ErRest/DownloadImage/id/' + id + '/user_id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, '_blank');
        win.focus()

        // fetch(this.state.apiUrl + '/ErRest/DownloadImage/id/' + id + '/user_id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, )
    }

    showStoryLink(storyLink) {
        var link = document.createElement("a");
        link.target = "_blank";
        link.href = storyLink;
        document.body.appendChild(link);
        link.click();
    }

    deleteStoryLink() {
        if (window.confirm('Are you sure delete this Link ?')) {
            fetch(this.state.apiUrl + '/ErRest/DeleteStoryLink/id/' + this.props.match.params.storyId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.getStoryDetails();
                    }
                })
        }
    }

    getSize(bytes, decimals) {
        if (bytes == 0) return '0 Bytes';
        var k = 1024,
            dm = decimals <= 0 ? 0 : decimals || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    getStatusClass(status) {
        switch (status) {
            case '128':
                return 'qa';
            case '127':
                return 'closed';
            case '126':
                return 'deferred';
            case '125':
                return 'blocked';
            case '124':
                return 'failed';
            case '123':
                return 'resolved';
            case '122':
                return 'qa';
            case '121':
                return 'active';
            case '120':
                return 'assigned';
            case '110':
                return 'assigned';
            case '109':
                return 'assigned';
            case '10':
                return 'assigned';
            case '50':
                return 'assigned';
            case '55':
                return 'active';
            case '60':
                return 'reopen';
            case '80':
                return 'resolved';
            case '82':
                return 'qa';
            case '83':
                return 'pm_rev';
            case '84':
                return 'pm_pass';
            case '85':
                return 'tested';
            case '88':
                return 'pro-ready';
            case '90':
                return 'closed';
            case '91':
                return 'tospec';
            case '92':
                return 'tospec';
            default:
                return 'new';
        }
    }

    getImageTypeClass(filename) {
        var ext = filename.split('.').pop();
        if (ext == filename)
            return "";
        return ext;
    }

    getReporter() {
        if (this.state.reporter) {
            return (
                <div class="er_moniter">
                    <div class="text-inded">{this.state.formatted_owners[this.state.reporter].name}</div>
                    <div class="pro_image pull-left">
                        {this.state.formatted_owners[this.state.reporter].attachment_url ? <img src={this.state.formatted_owners[this.state.reporter].attachment_url + this.state.formatted_owners[this.state.reporter].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[this.state.reporter].img_name}</span>}
                    </div>
                </div>
            )
        }
    }

    getAssignedTo() {
        if (this.state.assigned_to) {
            return (
                <div class="er_moniter">
                    <div class="text-inded">{this.state.formatted_owners[this.state.assigned_to].name}</div>

                    <div class="pro_image pull-left">
                        {this.state.formatted_owners[this.state.assigned_to].attachment_url ? <img src={this.state.formatted_owners[this.state.assigned_to].attachment_url + this.state.formatted_owners[this.state.assigned_to].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[this.state.assigned_to].img_name}</span>}
                    </div>
                </div>
            )
        }
    }

    close_story() {
        const fd = new FormData;
        fd.append('sequence_no', this.props.match.params.seqNo);
        if (window.confirm('Are you sure close this Story ?')) {
            fetch(this.state.apiUrl + '/ErRest/StoryClose/id/' + this.props.match.params.storyId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getStoryDetails();
                })
        }
    }

    reopen_story() {
        const fd = new FormData;
        fd.append('sequence_no', this.props.match.params.seqNo);
        if (window.confirm('Are you sure re-open this Story ?')) {
            fetch(this.state.apiUrl + '/ErRest/StoryReOpen/id/' + this.props.match.params.storyId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getStoryDetails();
                })
        }
    }

    ChangeStoryStatus() {
        const fd = new FormData;
        var status = document.getElementById('status').value;
        fd.append('status', status);
        fd.append('sequence_no', this.props.match.params.seqNo);
        fetch(this.state.apiUrl + '/ErRest/ChangeStoryStatus/id/' + this.props.match.params.storyId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getStoryDetails();
                    });
                } else {

                    this.setState({ message: findresponse.msg })
                }
            })
    }

    InsertMonitorER(feature_id) {
        let errors = {};
        if (this.state.value.length === undefined || this.state.value.length === 0) {
            errors["monitor"] = "This field is required.";
            this.setState({ errors: errors });
            return false;
        } else {
            const fd = new FormData;
            fd.append('ticket_inputs', JSON.stringify(this.state));
            fetch(this.state.apiUrl + '/ErRest/InsertMonitorER/id/' + feature_id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message: findresponse.msg }, function () {
                            this.getStoryDetails();
                            this.state.value = '';
                            errors["monitor"] = "";
                            this.setState({ errors: errors });
                        });
                    } else {
                        this.setState({ message: findresponse.msg })
                    }
                })
        }
    }

    deleteMonitor(monitor_id, monitor_name) {
        if (window.confirm('Are you sure to remove ' + monitor_name + ' ?')) {
            fetch(this.state.apiUrl + '/ErRest/DeleteMonitor/id/' + this.state.er_story.feature_id + '/userAuthKey/' + this.state.userAuthKey + '/monitor_id/' + monitor_id, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.getStoryDetails();
                    }
                })
        }
    }

    ChangeStoryOwner() {
        const fd = new FormData;
        var owner = document.getElementById('owner').value;
        fd.append('assign_to', owner);
        fd.append('sequence_no', this.props.match.params.seqNo);
        fetch(this.state.apiUrl + '/ErRest/ChangeStoryOwner/id/' + this.props.match.params.storyId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getStoryDetails();
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    delteimage(id, story_id, name) {
        if (window.confirm('Are you sure to delete ' + name + ' ?')) {
            fetch(this.state.apiUrl + '/ErRest/deleteStoryImage/id/' + id + '/er_id/' + story_id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getStoryDetails();
                })
        }
    }

    componentWillMount() {
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getStoryDetails();
        $(document).ready(function () {
            if (window.File && window.FileList && window.FileReader) {
                $("#files").on("change", function (e) {
                    var files = e.target.files,
                        filesLength = files.length;
                });
            } else {
                alert("Your browser doesn't support to File API")
            }
            $('.upload_btn label').click(function () {
                $(this).parent().find('.inputfile').click();
            });
            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();
                $input.on('change', function (e) {
                    var fileName = '';
                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();
                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });
                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });
            //Show More
            $('.show-more').on('click', function () {
                if ($(this).parent().find('.hide_mob').hasClass('active')) {
                    $(this).parent().find('.hide_mob').removeClass('active');
                }
                else {
                    $(this).parent().find('.hide_mob').addClass('active');
                }
                $('.show-more span').text() === 'Show Less' ? $('.show-more span').text('Show More') : $('.show-more span').text('Show Less');
                $('.show-more .fa').toggleClass('active');
            });
        });
    }

    onToggle(obj) {
        var obj = document.getElementById('showmore')
        if (obj.classList.contains('collapsed')) {
            obj.innerHTML = 'More Details >>';
        } else {
            obj.innerHTML = 'Hide Details >>';
        }
    }

    insertAcceptanceRequest() {
        const fd = new FormData;
        document.getElementById("add_acc_req").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/ErRest/InsertAcceptanceRequest/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId + '/id/' + this.props.match.params.storyId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                console.log(findresponse)
                if (findresponse.code == 200) {
                    document.getElementById("add_acc_req").innerHTML = "Sending....";
                    window.location.href = '/viewStory/' + this.props.match.params.storyId + '/sequence/' + this.props.match.params.seqNo;
                } else {
                    document.getElementById("add_acc_req").disabled = false;
                    this.setState({ accptanceErrorMessage: findresponse.msg })
                }
            })
    }

    onStartDateTextClick() {
        if (this.state.er_story.date_start) {
            let x = Date.parse(this.state.er_story.date_start);
            this.setState({ startdate: moment(x) })
        }
        else {
            this.setState({ startdate: '' })
        }
        document.getElementById('date_start_input').classList.remove("hidden");
        document.getElementById('date_start_text').classList.add("hidden");
    }

    onEndDateTextClick() {
        if (this.state.er_story.date_end) {
            let x = Date.parse(this.state.er_story.date_end);
            this.setState({ enddate: moment(x) })
        }
        else {
            this.setState({ enddate: '' })
        }
        document.getElementById('date_end_input').classList.remove("hidden");
        document.getElementById('date_end_text').classList.add("hidden");
    }

    startdateChange(event) {
        this.setState({ startdate: event, start_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }

    enddateChange(event) {
        this.setState({ enddate: event, end_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }

    onStartCloseClick() {
        document.getElementById('date_start_input').classList.add("hidden");
        document.getElementById('date_start_text').classList.remove("hidden");
    }

    onEndCloseClick() {
        document.getElementById('date_end_input').classList.add("hidden");
        document.getElementById('date_end_text').classList.remove("hidden");
    }
onStartSaveClick() {
        const fd = new FormData;
        fd.append('start_date', document.getElementById('start_date').value);
        fetch(this.state.apiUrl + '/ErRest/SaveStoryStartDate/id/' + this.props.match.params.storyId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getStoryDetails();
                    });
                }
                document.getElementById('date_start_input').classList.add("hidden");
                document.getElementById('date_start_text').classList.remove("hidden");
            })
    }
	 onEndSaveClick() {
        const fd = new FormData;
        fd.append('end_date', document.getElementById('end_date').value);
        fetch(this.state.apiUrl + '/ErRest/SaveStoryEndDate/id/' + this.props.match.params.storyId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getStoryDetails();
                    });
                }
                document.getElementById('date_end_input').classList.add("hidden");
                document.getElementById('date_end_text').classList.remove("hidden");
            })
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Er's" brecum_page="Story Detail" />
                <div class="right_col">
                    <div class="ticket_list">
                        <div class="loader-new"></div>
                        <div className="intranet_body hidden">
                            <div class="title mob er_ids">
                                <div class="er_id">
                                    <span class="er">Story Id :</span><HeaderMob page_name={this.state.er_story.feature_id + '_' + this.props.match.params.seqNo} />
                                </div>
                            </div>
                            <div class="top-row hidden-xs er_top">
                                <div class="left-section btn-muvi pull-left">
                                    {this.state.er_story.status != 90 ? (<Link to={`/EditStory/${this.state.er_story.id}/sequence/${this.props.match.params.seqNo}`} name={"max"} className="btn btn-sky">Edit</Link>)
                                        : ''
                                    }
                                    <Link to={`/viewEr/` + this.state.feature_id} name={"max"} className="btn btn-blue hidden-sm">Back</Link>
                                </div>
                                <div class="right-section btn-muvi">
                                    <div class="searchTicket er_dpt">
                                        <div class="filter">
                                            <select id="owner" class="form-control" name="assigned_to" value={this.state.assigned_to} onChange={this.onChange.bind(this, 'assigned_to')}>
                                                <option value={this.state.userId}>[Myself] </option>
                                                {
                                                    this.state.owners.map((dynamicData, key) =>
                                                        <option value={dynamicData.id}>{dynamicData.name}</option>
                                                    )
                                                }
                                            </select>
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                        <button type="submit" className="btn btn-blue" onClick={() => this.ChangeStoryOwner()} >Assign To</button>
                                    </div>
                                    <div class="searchTicket er_dpt">
                                        <div class="filter">
                                            <select class="form-control" name="status_name" id="status" value={this.state.status_name} onChange={this.onChange.bind(this, 'status')} >
                                                {
                                                    this.state.story_status.map((dynamicData, index) =>
                                                        <option value={dynamicData.key}>{dynamicData.value}</option>
                                                    )
                                                }
                                            </select>
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                        <button type="submit" className="btn btn-blue" onClick={() => this.ChangeStoryStatus()}>Change Status</button>
                                    </div>
                                    <Link to={`/cloneStory/${this.state.er_story.id}/sequence/${this.props.match.params.seqNo}`} name={"max"}><button className="btn btn-sky">Clone</button></Link>
                                    {this.state.er_story.status != 90 ? <button className="btn btn-blue btn-close" onClick={() => this.close_story()}>Close</button> : (this.state.er_story.status != 60 ? <button className="btn btn-blue btn-close" onClick={() => this.reopen_story()}>Re-Open</button> : '')}
                                </div>
                            </div>
                            <div class="request_details er row">
                                <div class="col-md-9 col-xs-12">
                                    <div class="form-section">
                                        <div class="er_title hidden-sm">Story Details</div>
                                        {this.state.er_story.initiative_name ? <div class="details">
                                            <div class="details_title">Initiative </div>
                                            <div class="details_des" dangerouslySetInnerHTML={{ __html: this.state.er_story.initiative_name }}></div>
                                        </div> : ''}
                                        <div class="details">
                                            <div class="details_title">Feature </div>
                                            <div class="details_des" dangerouslySetInnerHTML={{ __html: this.state.er_story.feature_name }}></div>
                                        </div>
                                        <div class="details">
                                            <div class="details_title">Story </div>
                                            <div class="details_des">{this.state.er_story.title ? <div dangerouslySetInnerHTML={{ __html: this.state.er_story.title }} /> : '--'}</div>
                                        </div>
                                        <div class="details">
                                            <div class="details_title">Status </div>
                                            <div class="details_des"><div class={'er_status ' + this.getStatusClass(this.state.er_story.status)}>{this.state.er_story.status ? this.state.config.story_status[this.state.er_story.status] : "--"}</div></div>
                                        </div>
                                        <a id="showmore" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" onClick={this.onToggle.bind()} href="javascript:void(0)">More Details >></a>
                                        <div class="collapse" id="collapseExample">
                                        <div class="details">
                                                <div class="details_title">Description </div>
                                                <div class="details_des">{this.state.er_story.description ? <div dangerouslySetInnerHTML={{ __html: this.state.er_story.description }} /> : '--'}</div>
                                        </div>
                                        </div>
                                        </div>
                                    <div>
                                        <div class="title mob er_ac">Acceptance Criteria </div>
                                        <div>
                                            {
                                                this.state.er_story.acceptance_criteria ? <div class="m_t_10 accept"><p dangerouslySetInnerHTML={{ __html: this.state.er_story.acceptance_criteria }}></p></div> :
                                                <div>
                                                    <div class="form-group m_t_10">
                                                        <textarea class="form-control" placeholder="Acceptance Criteria" name="input_story_acc" id="input_story_acc" onChange={this.onChange.bind(this, 'acceptance_criteria')}></textarea>
                                                        <span class="error">{this.state.accptanceErrorMessage}</span>
                                                    </div>
                                                    <button type="submit" name="add_acc_req" id="add_acc_req" class="btn btn-blue mob-btn" onClick={() => this.insertAcceptanceRequest()}>Submit</button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="request_details">
                                        <div class="tab-content customer-tab clearfix">

                                            <div id="exTab1" class="container title mob hidden-sm">
                                                <ul class="nav nav-pills">
                                                    <li class="active"><a href="#note" data-toggle="tab">Notes</a></li>
                                                    <li><a href="#history" data-toggle="tab">History</a></li>
                                                </ul>
                                            </div>

                                            <div class="tab-content customer-tab clearfix">
                                                <div className="tab-pane active" id="note">
                                                    <div class="row">
                                                        <div className="form-section ckeditor">
                                                            <CKEditor
                                                                activeClass="p10"
                                                                name='note'
                                                                content={this.state.note}
                                                                events={{
                                                                    "change": this.ckOnChange1
                                                                }}
                                                            />
                                                            <div id='note_autoseggestion'></div>
                                                            <span style={{ color: "red" }}>{this.state.errors["note"]}</span>
                                                        </div>

                                                        <div class="form-section ckeditor_upload">
                                                            <div class="upload">
                                                                <label>Add Attachment :</label>
                                                                <div class="upload_btn">
                                                                    <input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                                                    <label for="file-1">
                                                                        <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                                                        <span>Choose file</span>
                                                                        <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-section ckeditor">
                                                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.AddNote()}>Add Note</button>
                                                        </div>
                                                    </div>
                                                    <div className="feedback">
                                                        {this.state.notes.length > 0 ?
                                                            <h5 class="title"><span>View Note</span></h5>
                                                            : ''}
                                                        {
                                                            this.state.notes.map((data, key) =>
                                                                <div class="sub_feedback" id={'note' + data.id}>
                                                                    <div class="main">
                                                                        <div class="pro_image">
                                                                            {this.state.formatted_owners[data.user_id].attachment_url ? <img src={this.state.formatted_owners[data.user_id].attachment_url + this.state.formatted_owners[data.user_id].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[data.user_id].img_name}</span>}
                                                                        </div>
                                                                        <div class="fa-icon tooltips">
                                                                            {this.NoteEditCondition(data.id, data.note)}
                                                                        </div>
                                                                        <h6>{data.owner_name}</h6>
                                                                        <span class="date">{data.created_date}</span>
                                                                    </div>
                                                                    <div class="sub">
                                                                        <a href={'#note' + data.id} key={key} to={data.id} name={'note' + data.id}><span>Note {data.id}</span></a>
                                                                        <div class="note_list" dangerouslySetInnerHTML={{ __html: data.note }} />
                                                                    </div>
                                                                    {this.state.er_note_attachment[data.id] ?
                                                                        <div>
                                                                            {
                                                                                this.state.er_note_attachment[data.id].map((data, key) =>
                                                                                    <div class="attached" onClick={() => this.showImage(data.url, data.attachment_name)}  >
                                                                                        <i class="far fa-file"></i>{data.attachment_name}
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                        : ''}
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div class="tickets tab-pane " id="history">
                                                    {<div className="feedback">
                                                        <ul class="tickets_head">
                                                            <li class="intra_col_25">Date</li>
                                                            <li class="intra_col_25">User</li>
                                                            <li class="intra_col_25">Field</li>
                                                            <li class="intra_col_25">Change</li>
                                                        </ul>
                                                        {
                                                            this.state.story_history.map((ErHistory, key) =>
                                                                <ul class="tickets_number">
                                                                    <li class="intra_col_25">{ErHistory.created_date} </li>
                                                                    <li class="intra_col_25"> {this.state.formatted_owners[ErHistory.user_id].name}</li>
                                                                    <li class="intra_col_25">
                                                                        {ErHistory.type == 23 ? 'New Story' : (ErHistory.type == 24 && ErHistory.old_value != '' ? 'File Added : ' + ErHistory.old_value : (ErHistory.type == 0 && ErHistory.field_name == 'handler_id' ? 'Assigned To' : (ErHistory.type == 0 && ErHistory.field_name == 'status' ? 'Status Updated' : (ErHistory.type == 12 && ErHistory.old_value != '' ? 'Issue Monitored : ' + this.state.formatted_owners[ErHistory.old_value].name : (ErHistory.type == 2 && ErHistory.old_value != '' ? 'Note Added : ' + ErHistory.old_value : (ErHistory.type == 3 && ErHistory.old_value != '' ? 'Note Updated : ' + ErHistory.old_value : (ErHistory.type == 25 && ErHistory.old_value != '' ? 'File Deleted : ' + ErHistory.old_value : (ErHistory.type == 26 && ErHistory.new_value != '' ? <a href={'/viewStory/' + ErHistory.new_value} target="_blank">{'Story Cloned : ' + ErHistory.new_value}</a> : (ErHistory.type == 0 && ErHistory.field_name == 'reporter' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'Reporter Updated' : (ErHistory.type == 6 && ErHistory.old_value != '' ? 'Description Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'summary' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'Summary Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'priority' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'Priority Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'summary' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'Summary Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'status' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'Status Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'summary' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'Summary Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Start Date' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'Start Date Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'DEV ETA' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'DEV ETA Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Go-Live Date' && ErHistory.old_value != '' && ErHistory.new_value != '' ? 'Go-Live Date Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'acceptance_criteria' ? 'Acc. Criteria Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'story_text' ? 'Story Text Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'story_link' ? 'Story Link Updated' : '')))))))))))))))))))))}
                                                                    </li>
                                                                    <li class="intra_col_25">
                                                                        {ErHistory.type == 0 && ErHistory.field_name == 'handler_id' && ErHistory.old_value != '' && ErHistory.new_value != '' ? this.state.formatted_owners[ErHistory.old_value].name + ' => ' + this.state.formatted_owners[ErHistory.new_value].name : (ErHistory.type == 0 && ErHistory.field_name == 'status' && ErHistory.old_value != '' && ErHistory.new_value != '' ? this.state.config.story_status[ErHistory.old_value] + ' => ' + this.state.config.story_status[ErHistory.new_value] : ((ErHistory.type == 3 || ErHistory.type == 6) ? ((ErHistory.type == 6 || ErHistory.type == 3) ? <Link to={`/StoryHistoryRevision/${ErHistory.story_id}/type/${ErHistory.type}/rev/${ErHistory.old_value}`} name={"max"} target="_blank"><span className="color-sky">View Revision</span></Link> : '') : (ErHistory.type == 0 && ErHistory.field_name == 'reporter' && ErHistory.old_value != '' && ErHistory.new_value != '' ? this.state.formatted_owners[ErHistory.old_value].name + ' => ' + this.state.formatted_owners[ErHistory.new_value].name : (ErHistory.type == 0 && ErHistory.field_name == 'Start Date' && ErHistory.old_value != '' && ErHistory.new_value != '' ? ErHistory.old_value + ' => ' + ErHistory.new_value : (ErHistory.type == 0 && ErHistory.field_name == 'DEV ETA' && ErHistory.old_value != '' && ErHistory.new_value != '' ? ErHistory.old_value + ' => ' + ErHistory.new_value : (ErHistory.type == 0 && ErHistory.field_name == 'Go-Live Date' && ErHistory.old_value != '' && ErHistory.new_value != '' ? ErHistory.old_value + ' => ' + ErHistory.new_value : (ErHistory.type == 0 && ErHistory.field_name == 'summary' && ErHistory.old_value != '' && ErHistory.new_value != '' ? ErHistory.old_value + ' => ' + ErHistory.new_value : ErHistory.type == 0 && ErHistory.field_name == 'priority' && ErHistory.old_value != '' && ErHistory.new_value != '' ? this.state.config.priority[ErHistory.old_value] + ' => ' + this.state.config.priority[ErHistory.new_value] : (ErHistory.type == 0 && ErHistory.field_name == 'acceptance_criteria' ? ErHistory.old_value + ' => ' + ErHistory.new_value : (ErHistory.type == 0 && ErHistory.field_name == 'story_text' ? (ErHistory.old_value ? ErHistory.old_value : '') + ' => ' + (ErHistory.new_value ? ErHistory.new_value : '') : (ErHistory.type == 0 && ErHistory.field_name == 'story_link' ? (ErHistory.old_value ? ErHistory.old_value : '') + ' => ' + (ErHistory.new_value ? ErHistory.new_value : '') : ''))))))))))}
                                                                    </li>
                                                                </ul>
                                                            )
                                                        }
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-xs-12">
                                    <div class="form-section">
                                        <div class="er_title">Members</div>
                                        <div class="details er_member">
                                            <div class="details_title">Reporter </div>
                                            <div class="details_des">{this.getReporter()}</div>
                                        </div>
                                        <div class="details er_member">
                                            <div class="details_title">Assign To </div>
                                            <div class="details_des">{this.getAssignedTo()}</div>
                                        </div>
                                        <div class="details er_member">
                                            <div class="details_title">Monitoring </div>
                                            <div class="details_des">
                                                {
                                                    this.state.monitor_er.map((data, key) =>
                                                        <div class="tooltips">
                                                            <div class="tooltiptext">{data.name}</div>
                                                            <div onClick={() => this.deleteMonitor(data.id, data.name)} class="er_image pull-left">
                                                                {data.attachment ? <img src={data.attachment_url + data.attachment} title={data.name} /> : <span class="profile_first_name">{data.img_name}</span>}
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                <div class="selectOptions">
                                                    <MuiThemeProvider muiTheme={getMuiTheme()}>
                                                        <SelectField
                                                            multiple
                                                            fullWidth={true}
                                                            value={this.state.value}
                                                            onChange={this.handleChange}
                                                            maxHeight={200}
                                                        >
                                                            {this.state.owners.map((data, i) =>
                                                                <MenuItem
                                                                    value={data.id} key={data.id} primaryText={data.name} />)}
                                                        </SelectField>
                                                    </MuiThemeProvider>
                                                    <div class="clear"></div>
                                                    <div style={{ color: "red" }}>{this.state.errors["monitor"]}</div>
                                                    <button class="btn btn-sky" type="submit" onClick={() => this.InsertMonitorER(this.state.feature_id)}>ADD Monitor</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-section date">
                                            <div class="er_title">Date</div>
                                            <div class="details er_member">
                                                <div class="details_title">Submitted Date </div>
                                                <div class="details_des">{this.state.er_story.create_date && this.state.er_story.create_date != '00-00-0000' ? this.state.er_story.create_date : '--'} </div>
                                            </div>
                                            {/* <div class="details er_member">
                                                <div class="details_title">Start Date </div>
                                                <div class="details_des">{this.state.er_story.start_date && this.state.er_story.start_date != '00-00-0000' ? this.state.er_story.start_date : '--'} </div>
                                            </div>
                                            <div class="details er_member">
                                                <div class="details_title">End Date </div>
                                                <div class="details_des">{this.state.er_story.end_date && this.state.er_story.end_date != '00-00-0000' ? this.state.er_story.end_date : '--'} </div>
                                            </div> */}
 
                                            <div class="details er_member edit_calender">
                                                <div class="details_title">Start Date </div>
                                                <div class="details_des date_start_text ">
                                                    <div id='date_start_text' onClick={() => this.onStartDateTextClick()}>{this.state.er_story.start_date && this.state.er_story.start_date != '00-00-0000' ? this.state.er_story.start_date : '--'}</div>
                                                    <div class="hidden" id='date_start_input'>
                                                        <DatePicker
                                                            selected={this.state.startdate}
                                                            onChange={this.startdateChange}
                                                            placeholderText="Start Date"
                                                            id='start_date'
                                                            dateFormat="DD/MM/YYYY"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            minDate={this.state.createddate}
                                                            maxDate={this.state.enddate ? this.state.enddate : (this.state.golivedate ? this.state.golivedate : '')}
                                                            isClearable={true}
                                                        />
                                                        <div class="edro_pac">
                                                            <span class="icon_download" onClick={() => this.onStartSaveClick()}>
                                                                <i class="fal fa-check-circle"></i>
                                                            </span>
                                                            <span class="icon_delete" onClick={() => this.onStartCloseClick()}>
                                                                <i class="fal fa-minus-circle"></i>
                                                            </span>
                                            </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="details er_member edit_calender">
                                                <div class="details_title">End Date </div>
                                                <div class="details_des date_end_text">
                                                    <div id='date_end_text' onClick={() => this.onEndDateTextClick()}>{this.state.er_story.end_date && this.state.er_story.end_date != '00-00-0000' ? this.state.er_story.end_date : '--'}</div>
                                                    <div class="hidden" id='date_end_input'>
                                                        <DatePicker
                                                            selected={this.state.enddate}
                                                            onChange={this.enddateChange}
                                                            placeholderText="End Date"
                                                            id='end_date'
                                                            dateFormat="DD/MM/YYYY"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            minDate={this.state.startdate ? this.state.startdate : (this.state.createddate ? this.state.createddate : '')}
                                                            maxDate={this.state.golivedate}
                                                            isClearable={true}
                                                        />
                                                        <div class='edro_pac'>
                                                            <span class="icon_download" onClick={() => this.onEndSaveClick()}>
                                                                <i class="fal fa-check-circle"></i>
                                                            </span>
                                                            <span class="icon_delete" onClick={() => this.onEndCloseClick()}>
                                                                <i class="fal fa-minus-circle"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="details er_member">
                                                <div class="details_title">Go Live Date </div>
                                                <div class="details_des">{this.state.er_story.go_live_date && this.state.er_story.go_live_date != '00-00-0000' ? this.state.er_story.go_live_date : '--'} </div>
                                            </div>
                                        </div>
                                        <div class="form-section">
                                            <div class="er_title">Mock Up</div>
                                            <div class="details er_member">
                                                {this.state.story_attachment.map((data, key) =>
                                                    <div class="attach_wrapper">
                                                        <div class={'icon icon-' + this.getImageTypeClass(data.attachment_name)}>
                                                            {this.getImageTypeClass(data.attachment_name)}
                                                        </div>
                                                        <div class="file_name text-inded">
                                                            {data.attachment_name}
                                                            <div class="file_size">
                                                                <span>{this.getSize(data.size, 2)} &emsp;</span>
                                                                <span>{data.created_date}</span>
                                                            </div>
                                                        </div>
                                                        <div class="edit_delete">
                                                            <span class="icon_download" onClick={() => this.downloadImage(data.id)}  >
                                                                <i class="fas fa-arrow-circle-down"></i>
                                                            </span>
                                                            <span class="icon_delete" onClick={() => this.delteimage(data.id, data.entity_id, data.attachment_name)}  >
                                                                <i class="fa fa-trash"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.er_story.story_text != '' && this.state.er_story.story_link != '' ?
                                                    <div class="attach_wrapper">
                                                        <div class={'icon icon-jpg'}>
                                                            <i class="fas fa-link hidden-sm"></i>
                                                        </div>
                                                        <div class="file_name text-inded">
                                                            {this.state.er_story.story_text}
                                                        </div>
                                                        <div class="edit_delete">
                                                            <span class="icon_download" onClick={() => this.showStoryLink(this.state.er_story.story_link)}>
                                                                <i class="fas fa-arrow-circle-down"></i>
                                                            </span>
                                                            <span class="icon_delete" onClick={() => this.deleteStoryLink()}>
                                                                <i class="fa fa-trash"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        )
    }
}

export default ViewStory;



// WEBPACK FOOTER //
// ./src/components/er/viewStory.js